module.exports = __webpack_public_path__ + "tile-photogallery.png";


//////////////////
// WEBPACK FOOTER
// ./app/tile-photogallery.png
// module id = 4
// module chunks = 0